<template>
  <div :class="bindPackageClass" :style="pcContentStyle">
    <div class="public-package-pad" :style="contentStyle">
      <div class="title-container">
        <div class="title" :style="mFontColor" v-html="skuTitleMsg"></div>
        <SkuTipsPopover />
      </div>

      <div class="sku-list-content" v-if="skuKeyList.length">
        <div
          v-for="(item, index) in skuKeyList"
          :key="index"
          :class="[
            'sku-title',
            skuActiveKey === item ? 'active' : '',
            index === 0 ? 'lt' : 'rt',
          ]"
          :style="[skuActiveKey === item ? cardActiveStyles : cardStyles]"
          @click="handleToggle(item)"
        >
          <span :style="mFontColor">{{ item }}</span>
        </div>
      </div>
      <div
        :class="['content', skuKeyList.length ? 'content-btm' : '']"
        :style="cardActiveStyles1"
      >
        <div class="search-content" v-if="skutEmpty">
          <input
            type="text"
            name=""
            class="search-input"
            :placeholder="placeholderText"
            :style="searchIuputStyles"
            @input="fuzzySearch"
            v-model="searchValue"
          />
          <MBIcon
            :size="iconSize"
            name="icon-search"
            :color="mFontColor.color"
          />
        </div>

        <div class="sku-list">
          <div
            v-for="(item, index) in skuList"
            :class="['sku-case', skuActiveSkuid === item.skuId ? 'active' : '']"
            :key="index"
            @click="handleActive({ item, index })"
          >
            <template v-if="getSkuIcon(item)">
              <img :src="getSkuIcon(item)" alt="logo" class="sku-logo" />
            </template>
            <div class="info">
              <p :style="mFontColor">{{ item.skuName.split('+')[0] }}</p>
              <p
                :style="mFontColor"
                class="reward"
                v-if="item.skuName.indexOf('+') !== -1"
              >
                +{{ item.skuName.split('+')[1] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import debounce from 'lodash/debounce'
  import SkuTipsPopover from '@/components/SkuTipsPopover'
  import MBIcon from '@/components/MBIcon'
  import { createdOrderNeedLoginGames } from '@page_detail/config'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { isJsonString } from '@/utils/tool'

  export default {
    name: 'newCategorySkuTemplate',
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      SkuTipsPopover,
    },
    data() {
      return {
        skutEmpty: true, // sku 不存在的时候 不显示搜索框
        skuActiveKey: '', // 切换头部分类的Key
        skuKeyList: [], // SKU分类的标题
        skuList: [], // SKU的数据
        skuActiveSkuid: '',
        searchValue: '', // 搜索的SkuName
      }
    },
    computed: {
      ...mapState(['gameName', 'isMobile', 'isDesktop']),
      ...mapGetters('detail', ['filterCurrencySkus']),
      ...mapGetters([
        'isRuStarMaker',
        'isParallelRequestsGame',
        'isMySoulLand3d',
      ]),

      skuTitle() {
        const fgame = this.isRuStarMaker ? 'publicDetails' : this.gameName
        const skuTitleKey = this.$te(`${fgame}.sku_title`)
        const skuTitle = skuTitleKey
          ? this.$t(`${fgame}.sku_title`)
          : this.$t(`publicDetails.sku_title`)
        return skuTitle
      },

      placeholderText() {
        if (this.isMySoulLand3d) {
          return this.$t(`${this.gameName}.search_skus`)
        }
        return this.$t('publicDetails.search_skus')
      },

      skuTitleMsg() {
        const isHackRes = createdOrderNeedLoginGames.includes(this.gameName)
        if (this.uidModuleType === 6) return `2.&nbsp;${this.skuTitle}`
        if (this.awardType !== 2) return `1.&nbsp;${this.skuTitle}`
        return isHackRes
          ? `1.&nbsp;${this.skuTitle}`
          : `2.&nbsp;${this.skuTitle}`
      },

      iconSize() {
        if (this.isDesktop) return 22
        if (this.isMobile) return 50
        return 50
      },

      pcContentStyle() {
        if (this.isMobile) return {}
        return {
          background: this.moduleBackColor.backgroundColor,
          '--mFontColor': this.mFontColor.color,
          '--pcBackdColor':
            hexToRgba(this.pcBackdColor.backgroundColor, 0.6) || 'red',
        }
      },
      contentStyle() {
        return {
          background: this.moduleBackColor.backgroundColor,
          '--mFontColor': this.mFontColor.color,
          '--pcBackdColor':
            hexToRgba(this.mbackdColor.backgroundColor, 0.6) || 'red',
        }
      },
      searchIuputStyles() {
        return {
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
        }
      },
      cardStyles() {
        return {
          background: this.unSelectedTabColor,
        }
      },
      bindPackageClass() {
        const defaultClass = ['gos-template']
        let device = ''

        if (this.isDesktop) {
          device = `${defaultClass[0]}-desktop`
        }
        if (this.isMobile) {
          device = `${defaultClass[0]}-mobile`
        }

        return defaultClass.concat(device)
      },
      cardActiveStyles() {
        return {
          background: this.selectedTabColor,
          color: this.mFontColor,
        }
      },
      cardActiveStyles1() {
        return {
          background: hexToRgba(this.mbackdColor.backgroundColor, 0.1),
        }
      },
    },

    watch: {
      // 初始选中状态
      filterCurrencySkus: {
        handler(newVal) {
          // object of Array
          if (
            (Array.isArray(newVal) && newVal.length === 0) ||
            Object.keys(newVal).length === 0
          ) {
            this.skuList = []
            this.skuKeyList = []
            this.skutEmpty = false
            return
          }

          const _skuList = this.cleansku(newVal)
          if (!_skuList.length) return

          this.skutEmpty = !!_skuList.length
          this.defaultAction(_skuList)
          this.skuList = _skuList
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.fuzzySearch = debounce(this.fuzzySearch, 300)
    },
    methods: {
      ...mapMutations(['detail/setCheckSkuItem', 'detail/setChekOuterSkuItem']),

      defaultAction(list) {
        this.handleActive({ item: list[0], index: 0 })
      },

      // warn 单独为【GOK】做过滤的限制
      // 为了防止后期还有相同的逻辑处理、去掉以游戏维度的限制
      cleansku(skulist) {
        if (skulist === null) return

        let filterList = []

        // 如果当前是对象、但是是数组形式、那么认为没有TAB的切换的KEY
        if (Array.isArray(skulist)) {
          filterList = skulist
        } else {
          this.skuKeyList = Object.keys(skulist)
          this.skuActiveKey = this.skuKeyList[0]
          filterList = skulist[this.skuKeyList[0]]
        }

        return filterList
      },

      handleToggle(item) {
        if (!this.skutEmpty) return
        const res = this.filterCurrencySkus[item]
        if (!res.length) return

        this.skuList = res
        this.skuActiveKey = item
        this.searchValue = ''
        this.handleActive({ item: res[0] })
      },

      // 模糊搜索
      fuzzySearch() {
        const searchValue = this.searchValue.trim()
        let skulist = []
        let filterSku = []

        if (
          typeof this.filterCurrencySkus === 'object' &&
          Array.isArray(this.filterCurrencySkus)
        ) {
          skulist = this.filterCurrencySkus
        } else {
          skulist = this.filterCurrencySkus[this.skuActiveKey]
        }

        if (skulist.length === 0) return

        // 搜索的时候取消选中的状态
        // this.skuActiveSkuid = searchValue.trim() ? null : skulist[0].skuId
        // this.skuActiveSkuid = searchValue.trim()

        filterSku = skulist.filter(
          (item) =>
            item.skuName.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
        )

        // 搜索的时候 是否含有选中的状态
        // const haveItems = filterSku.some(
        //   (item) => this.skuActiveSkuid === item.skuId
        // )
        // if (!haveItems) {
        //   this['detail/setCheckSkuItem']({})
        // }

        if (searchValue === '') {
          this.skuActiveSkuid = skulist[0].skuId
          this['detail/setCheckSkuItem'](skulist[0])
        } else {
          this['detail/setCheckSkuItem']({})
          this.skuActiveSkuid = ''
        }

        this.skuList = filterSku
      },

      getSkuIcon(item) {
        const { skuExtraInfo, skuUrl = '' } = item
        if (this.isParallelRequestsGame && skuUrl) {
          return skuUrl
        }
        if (skuExtraInfo && isJsonString(skuExtraInfo)) {
          return JSON.parse(skuExtraInfo)?.background_url || null
        }
        return null
      },

      handleActive({ item }) {
        this.skuActiveSkuid = item.skuId
        this['detail/setCheckSkuItem'](item)

        if (this.isParallelRequestsGame) {
          const _item = JSON.stringify(item)
          this['detail/setChekOuterSkuItem'](_item)
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
